import React from 'react';

const Loader = () => <div className="custom-loader"/>

export default Loader;
